import React, { useState, useEffect } from "react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import API_ENDPOINTS from "../../config/api";
import axios from "axios";

const BroadcastPage = () => {
  const [recipients, setRecipients] = useState([]);
  const [selectedRecipient, setSelectedRecipient] = useState("all");
  const [messageType, setMessageType] = useState("text");
  const [messageContent, setMessageContent] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [connection, setConnection] = useState(null);

  // 🔹 Hàm load lại toàn bộ inbox từ API
  const loadMessages = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.getBroadcastNotifications, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setMessages(res.data.broadcasts || []); // ✅ lấy đúng field từ backend
    } catch (error) {
      console.error("❌ Lỗi load broadcast:", error);
    }
  };

  // 🔹 Lấy danh sách phòng ban + khởi tạo kết nối
  useEffect(() => {
    // Lấy danh sách phòng ban
    fetch(API_ENDPOINTS.getDepartments, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => res.json())
      .then((data) => setRecipients(data))
      .catch(console.error);

    // Tạo connection SignalR
    const newConnection = new HubConnectionBuilder()
      .withUrl(API_ENDPOINTS.broadcastHub, {
        accessTokenFactory: () => localStorage.getItem("token"),
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    setConnection(newConnection);

    // Load tin nhắn lần đầu
    loadMessages();
  }, []);

  // 🔹 Bắt sự kiện realtime từ SignalR
  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          console.log("✅ Connected to BroadcastHub");

          connection.on("ReceiveBroadcast", (msg) => {
            // Khi có broadcast mới → đưa lên đầu danh sách
            setMessages((prev) => [msg, ...prev]);

            // 🔄 Đồng bộ chuông thông báo
            if (window.fetchNotifications) {
              window.fetchNotifications();
            }
          });
        })
        .catch((err) => console.error("❌ Connection failed: ", err));
    }
  }, [connection]);

  // 🔹 Gửi broadcast
  const handleSendBroadcast = async () => {
    try {
      const formData = new FormData();
      formData.append("Recipient", selectedRecipient);
      formData.append("MessageType", messageType);

      if (messageType === "text") {
        formData.append("MessageContent", messageContent);
      } else if (messageType === "image" && imageFile) {
        formData.append("MessageContent", messageContent || "");
        formData.append("Image", imageFile);
      } else {
        formData.append("Image", "");
      }

      const res = await axios.post(API_ENDPOINTS.sendBroadcast, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      });

      console.log("✅ Broadcast success:", res.data);

      // Reset form
      setMessageContent("");
      setImageFile(null);

      // 🔄 Sau khi gửi → load lại inbox từ API
      loadMessages();

      // 🔄 Gọi lại API chuông để cập nhật số lượng thông báo
      if (window.fetchNotifications) {
        window.fetchNotifications();
      }
    } catch (error) {
      console.error("❌ Error broadcast:", error.response?.data || error);
      alert("Gửi broadcast thất bại!");
    }
  };

  return (
    <div className="container my-5">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h2 className="mb-0">📢 Gửi Tin nhắn Broadcast</h2>
        </div>

        <div className="card-body">
          {/* Đối tượng nhận */}
          <div className="mb-3">
            <label className="form-label fw-bold">Đối tượng nhận:</label>
            <select
              value={selectedRecipient}
              onChange={(e) => setSelectedRecipient(e.target.value)}
              className="form-select"
            >
              <option value="all">Tất cả nhân viên</option>
              {recipients.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name}
                </option>
              ))}
            </select>
          </div>

          {/* Loại tin nhắn */}
          <div className="mb-3">
            <label className="form-label fw-bold">Loại tin nhắn:</label>
            <select
              value={messageType}
              onChange={(e) => setMessageType(e.target.value)}
              className="form-select"
            >
              <option value="text">Văn bản</option>
              <option value="image">Hình ảnh</option>
            </select>
          </div>

          {/* Nội dung */}
          <div className="mb-3">
            <label className="form-label fw-bold">Nội dung tin nhắn:</label>
            {messageType === "text" ? (
              <textarea
                value={messageContent}
                onChange={(e) => setMessageContent(e.target.value)}
                rows="4"
                className="form-control"
              />
            ) : (
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
                className="form-control"
              />
            )}
          </div>

          <button
            onClick={handleSendBroadcast}
            className="btn btn-primary w-100"
          >
            📤 Gửi tin nhắn
          </button>
        </div>

        {/* Inbox */}
        
      </div>
    </div>
  );
};

export default BroadcastPage;
